import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** Retry the function using exponential backoff */
var _exponentialRetry = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var fn, _ref$maxRetries, maxRetries, _ref$retryCount, retryCount, _ref$delay, delay, errorFilter;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fn = _ref.fn, _ref$maxRetries = _ref.maxRetries, maxRetries = _ref$maxRetries === void 0 ? 3 : _ref$maxRetries, _ref$retryCount = _ref.retryCount, retryCount = _ref$retryCount === void 0 ? 0 : _ref$retryCount, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 1000 : _ref$delay, errorFilter = _ref.errorFilter;
          _context.prev = 1;
          _context.next = 4;
          return fn();
        case 4:
          return _context.abrupt("return", _context.sent);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
          if (!(errorFilter && !errorFilter(_context.t0))) {
            _context.next = 11;
            break;
          }
          throw _context.t0;
        case 11:
          if (!(retryCount >= maxRetries)) {
            _context.next = 13;
            break;
          }
          throw _context.t0;
        case 13:
          _context.next = 15;
          return new Promise(function (resolve) {
            return setTimeout(resolve, delay);
          });
        case 15:
          _context.next = 17;
          return _exponentialRetry({
            fn: fn,
            maxRetries: maxRetries,
            retryCount: retryCount + 1,
            delay: delay * 2,
            errorFilter: errorFilter
          });
        case 17:
          return _context.abrupt("return", _context.sent);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7]]);
  }));
  return function exponentialRetry(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export { _exponentialRetry as exponentialRetry };